import {
  SimpleColumn,
  SimpleSortableTable,
} from "../../../../../components/ui/simple-sortable-table";
import { ResumoDescricao } from "../types";

const moeda = (centavos: number) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(centavos / 100);

const columns: SimpleColumn<ResumoDescricao>[] = [
  {
    key: "descricao",
    label: "Descrição",
    cellClassName: "font-medium",
  },
  {
    key: "qtd",
    label: "Lançamentos",
    headClassName: "w-36 text-right",
    cellClassName: "text-right",
    render: (linha) => linha.qtd.toLocaleString("pt-BR"),
  },
  {
    key: "valor",
    label: "Valor",
    headClassName: "w-44 text-right",
    cellClassName: "text-right whitespace-nowrap",
    render: (linha) => moeda(linha.valor),
  },
];

interface DescricaoSummaryTableProps {
  rows: ResumoDescricao[];
}

export function DescricaoSummaryTable({ rows }: DescricaoSummaryTableProps) {
  // O total sai daqui e não do card: este resumo cobre o romaneio inteiro do dia,
  // enquanto o "Valor de Face Acumulado" desconta os lançamentos sem entregador.
  const total = rows.reduce((acc, linha) => acc + linha.valor, 0);
  const lancamentos = rows.reduce((acc, linha) => acc + linha.qtd, 0);

  return (
    <div className="space-y-2">
      <div className="rounded-md border">
        <SimpleSortableTable
          columns={columns}
          rows={rows}
          rowKey={(linha, index) => linha.descricao || index}
        />
      </div>
      <div className="flex justify-end gap-6 px-1 text-sm">
        <span className="text-muted-foreground">
          {lancamentos.toLocaleString("pt-BR")} lançamentos
        </span>
        <span className="font-semibold">Total do romaneio: {moeda(total)}</span>
      </div>
    </div>
  );
}
